import ActionHelper from 'helpers/action'

// constants
export const EXPORT_TO_CSV = 'export/EXPORT_TO_CSV'

export const exportToCsv = ActionHelper.createActionObj(EXPORT_TO_CSV)
